// this file is automatically generated by git.version.ts script
export const versions = {version: '2.9.34', revision: '64b4704', branch: 'HEAD'};


// WEBPACK FOOTER //
// ./src/environments/versions.ts